const request = {    
    baseUrl: '../../static/data', 
    baseUrl1: 'https://qyscallback.getac.com.cn/api/Contract/',   
}

export default request;


// WEBPACK FOOTER //
// ./src/utils/request.js